import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = {
    debounce: { type: Number, default: 300 },
    minLength: { type: Number, default: 3 }
  }

  connect() {
    this._timeout = null
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  filter(event) {
    const input = event.target

    if (input.type === "text") {
      const value = input.value.trim()
      if (value.length > 0 && value.length < this.minLengthValue) return
    }

    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, this.debounceValue)
  }
}
